var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-layout',{attrs:{"code":403,"error":"Нет доступа"}})}
var staticRenderFns = []

export { render, staticRenderFns }